import request from '@/utils/request'

let UserApi = {

    /*用户登录*/
    login(data, errorback) {
        return request._post('/shop/passport/login', data, errorback);
    },
    /*退出登录*/
    loginOut(data, errorback) {
        return request._post('/shop/passport/logout', data, errorback);
    },
    /*添加用户*/
    adduser(data, errorback) {
        return request._post('/shop/user.user/add', data, errorback);
    },

    /*修改用户*/
    edituser(data, errorback) {
        return request._post('/shop/user.user/edit', data, errorback);
    },
     /*修改代理老板*/
     editAgent(data, errorback) {
        return request._post('/shop/user.user/editAgent', data, errorback);
    },
    /*充值*/
    userRecharge(data, errorback) {
        return request._post('/shop/user.user/recharge', data, errorback);
    },
    /*删除用户*/
    deleteuser(data, errorback) {
        return request._post('/shop/user.user/delete', data, errorback);
    },

    /*用户列表*/
    userlist(data, errorback) {
        return request._post('/shop/user.user/index', data, errorback);
    },
    /*等级列表*/
    gradelist(data, errorback) {
        return request._post('/shop/user.grade/index', data, errorback);
    },
    /*添加等级*/
    addgrade(data, errorback) {
        return request._post('/shop/user.grade/add', data, errorback);
    },
    /*修改等级*/
    editGrade(data, errorback) {
        return request._post('/shop/user.grade/edit', data, errorback);
    },
    /*删除等级*/
    deletegrade(data, errorback) {
        return request._post('/shop/user.grade/delete', data, errorback);
    },
    /*等级开通列表*/
    getOrderList(data, errorback) {
        return request._post('/shop/user.grade/order', data, errorback);
    },
    /*用户余额*/
    BalanceLog(data, errorback) {
        return request._post('/shop/user.Balance/log', data, errorback);
    },
    /*充值记录*/
    RechargeOrder(data, errorback) {
        return request._post('/shop/user.Recharge/order', data, errorback);
    },
    /*修改密码*/
    EditPass(data, errorback) {
        return request._post('/shop/passport/editPass', data, errorback);
    },
    /*用户等级*/
    structureGrade(data, errorback) {
        return request._post('/shop/user.Structure/grade', data, errorback);
    },
    /*用户结构*/
    structureList(data, errorback) {
        return request._post('/shop/user.Structure/user', data, errorback);
    },
    /*佣金记录*/
    AgentLog(data, errorback) {
        return request._post('/shop/user.agent_log/index', data, errorback);
    },
     /* 积分区域记录*/
     RegionLog(data, errorback) {
        return request._post('/shop/user.agent_log/regionlog', data, errorback);
    },
    /*佣金记录*/
    AgentCapital(data, errorback) {
        return request._post('/shop/user.agent_log/agentCapital', data, errorback);
    },
    /*代理老板*/
    agentboss(data, errorback) {
        return request._post('/shop/user.agent/boss', data, errorback);
    },
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js